import React from "react";
import { BlogProvider } from "./BlogContext";
import { StoriesProvider } from "./StoryContext";
import { NoticesProvider } from "./NoticeContext";
import { TestimonialsProvider } from "./TestomonialsContext";
import { FAQsProvider } from "./FAQsContext";
import { TrustedCollegeProvider } from "./TrustedCollegeContext";
import { ProgramOfferedProvider } from "./ProgramOfferedContext";
import {StudentAchievementProvider} from "./StudentAchievementContext"

const DataProvider = ({ children }) => {
  return (
    <BlogProvider>
      <StoriesProvider>
        <NoticesProvider>
          <TestimonialsProvider>
            <StudentAchievementProvider>
              <FAQsProvider>
                <ProgramOfferedProvider>
                  <TrustedCollegeProvider>{children}</TrustedCollegeProvider>
                </ProgramOfferedProvider>
              </FAQsProvider>
            </StudentAchievementProvider>
          </TestimonialsProvider>
        </NoticesProvider>
      </StoriesProvider>
    </BlogProvider>
  );
};

export default DataProvider;
